export const DividerLabel = (props: any) => {
  return <div className={props.className}>{props.text}</div>;
};
